var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9616 0.558289C7.30012 0.558289 0.277344 6.99405 0.277344 14.9358C0.277344 18.0512 1.36982 20.9269 3.20958 23.2832L0.377148 30.1196C0.101345 30.7871 0.417928 31.5502 1.08436 31.827C1.41883 31.9651 1.77619 31.9562 2.08491 31.827L10.4252 28.3732C12.1476 28.9706 14.0088 29.313 15.9616 29.313C24.626 29.313 31.6459 22.8733 31.6459 14.9358C31.6459 6.99405 24.626 0.558289 15.9616 0.558289ZM9.42641 16.8961C8.34252 16.8961 7.46575 16.0183 7.46575 14.9358C7.46575 13.8508 8.34252 12.9751 9.42641 12.9751C10.5089 12.9751 11.3871 13.8508 11.3871 14.9358C11.3871 16.0183 10.5089 16.8961 9.42641 16.8961ZM15.9616 16.8961C14.8777 16.8961 14.0009 16.0183 14.0009 14.9358C14.0009 13.8508 14.8777 12.9751 15.9616 12.9751C17.0441 12.9751 17.9223 13.8508 17.9223 14.9358C17.9223 16.0183 17.0441 16.8961 15.9616 16.8961ZM22.4968 16.8961C21.4129 16.8961 20.5365 16.0183 20.5365 14.9358C20.5365 13.8508 21.4129 12.9751 22.4968 12.9751C23.5789 12.9751 24.4575 13.8508 24.4575 14.9358C24.4575 16.0183 23.5789 16.8961 22.4968 16.8961Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.be5e7f1b8847c22e60d3f0784e66bf28.svg";
export { ForwardRef as ReactComponent };